var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$props.itemDetail.componentSubcode === "ts_1" ||
    _vm.$props.itemDetail.componentSubcode === "ts_3"
      ? _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
              "align-items": "center",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "s-box",
                style: { borderRadius: _vm.searchStyle == 1 ? "6px" : "20px" },
              },
              [
                _c("i", {
                  staticClass: "el-icon-search",
                  staticStyle: { "margin-left": "10px" },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                },
              },
              _vm._l(_vm.dataList, function (item, index) {
                return _c("img", {
                  key: index,
                  staticStyle: { height: "25px", "margin-left": "10px" },
                  attrs: {
                    src: item.bannerPic
                      ? item.bannerPic
                      : require("@/assets/customPage/tp_icon.png"),
                  },
                })
              }),
              0
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.itemDetail.componentSubcode === "ts_2" ||
    _vm.$props.itemDetail.componentSubcode === "ts_4"
      ? _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
              "align-items": "center",
            },
          },
          [
            _c("img", {
              staticStyle: { height: "25px", "margin-right": "10px" },
              attrs: {
                src: _vm.dataList[0].bannerPic
                  ? _vm.dataList[0].bannerPic
                  : require("@/assets/customPage/tp_icon.png"),
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "s-box",
                style: { borderRadius: _vm.searchStyle == 1 ? "6px" : "20px" },
              },
              [
                _c("i", {
                  staticClass: "el-icon-search",
                  staticStyle: { "margin-left": "10px" },
                }),
              ]
            ),
            _vm._v(" "),
            _vm._l(
              _vm.dataList.filter(function (i, m) {
                return m != 0
              }),
              function (item, index) {
                return _c("img", {
                  key: index,
                  staticStyle: { height: "25px", "margin-left": "10px" },
                  attrs: {
                    src: item.bannerPic
                      ? item.bannerPic
                      : require("@/assets/customPage/tp_icon.png"),
                  },
                })
              }
            ),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$props.itemDetail.componentSubcode === "ts_5"
      ? _c("div", {}, [
          _vm.dataList.length > 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "margin-bottom": "6px",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c("el-image", {
                        staticStyle: { height: "25px" },
                        attrs: {
                          src: _vm.dataList[0].bannerPic
                            ? _vm.dataList[0].bannerPic
                            : require("@/assets/customPage/tp_o_icon.png"),
                          fit: "fill",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    _vm._l(
                      _vm.dataList.filter(function (i, m) {
                        return m != 0
                      }),
                      function (item, index) {
                        return _c("el-image", {
                          key: index,
                          staticStyle: {
                            height: "25px",
                            "margin-left": "10px",
                          },
                          attrs: {
                            src: item.bannerPic
                              ? item.bannerPic
                              : require("@/assets/customPage/tp_icon.png"),
                            fit: "fill",
                          },
                        })
                      }
                    ),
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "s-box",
              style: { borderRadius: _vm.searchStyle == 1 ? "6px" : "20px" },
            },
            [
              _c("i", {
                staticClass: "el-icon-search",
                staticStyle: { "margin-left": "10px" },
              }),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }